import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		<div style="text-align: justify;">
			<p class="mb-3">
				Когда хмурым декабрьским утром Солнце, хоть из-за туч, но всё же освещает Землю, у меня вырывается крик: «Как, для всех и даром?!?
			</p>
			
			<p class="mb-3">
				Оно появится каждое утро, каждое утро будет свет, и его никто не выключит?? 
				Никто не может его дозировать для нас, заставляя замирать, когда света нет, и оживлённо, вприпрыжку быстренько всё делать, пока свет есть? 
			</p>
			
			<p class="mb-3">
				Нет у дневного света хозяина, который нажатием кнопки активирует и дезактивирует нас, как подключённые к сети приборчики?!?
			</p>
			
			<p class="mb-3">
				Да разве это позволено – для всех и даром??
			</p>
			
			<p class="mb-3">
				Такое может быть в мире?!?»
			</p>
			
			<p class="mb-3">
				Так кричу я; и хмурый день быстро теряет свет. 
				К 4-ём часам уже сгущается мрак. 
			</p>
			
			<p class="mb-3">
				И в темноте мы покорно ждём, когда нам включат свет. 
			</p>

		</div>
		`
	)
}

const itemName = {
	rus: `Когда хмурым декабрьским утром...`
}

const itemDate = {
	rus: `19 января 2023`
}

const item = {
	itemlink: getLink(itemName.rus.replace('...', '')),
	rus: {
		itemName: itemName.rus,
		itemDate: itemDate.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;